import { RECRUITEE_BACKEND } from '@core/environment-legacy/staging';

import type { ReferralsEnvironment } from './interface';

export const environment: ReferralsEnvironment = {
  environmentName: 'staging',
  angularProdMode: true,
  analytics: {
    isEnabled: true,
    key: '57b8b354c54a93cd67f0e70c1fa6fc8b',
    requiredFeatureFlag: true,
  },
  i18n: {
    phraseAppProjectId: '33b93fa8c87183f3257609a570160087',
    editorEnabled: true,
  },
  hmr: false,
  protocol: RECRUITEE_BACKEND.protocol,
  domain: RECRUITEE_BACKEND.domain,
  authUrl: RECRUITEE_BACKEND.authUrl,
  apiUrl: RECRUITEE_BACKEND.apiUrl,
  appUrl: RECRUITEE_BACKEND.appUrl,
  webAppUrl: RECRUITEE_BACKEND.webAppUrl,
  landingPageUrl: RECRUITEE_BACKEND.appUrl,
  recaptchaSiteKey: '6LdznlAUAAAAAGaYOdwE_id-rzKrOvsc-a-LHRGl',
  websocketUrl: 'wss://api.s.recruitee.com/referral_portal_socket',
  resolveSubdomainFromHost: false,
  sentry: {
    dsn: 'https://6f06cd03a6384f0f969607be397ea68d@o18167.ingest.us.sentry.io/1440983',
    environmentName: 'development',
  },
};
